<template>
  <div class="px-4 py-6 bg-white border rounded-md border-theme-100">
    <div class="h-2.5 bg-theme-100 rounded-full w-48 mb-2"></div>
    <div class="h-2 bg-gray-200 rounded-full max-w-[300px] mb-4"></div>
    <div class="flex justify-between w-full gap-2">
      <div class="h-2 bg-gray-300 rounded-full w-36"></div>
      <div class="w-16 h-4 bg-gray-100 rounded-full"></div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
